const isLoggedIn = (state) => {
  return (state.jwt != null)
}

export default {
  isLoggedIn,
}